/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const formEndingSlice = createSlice({
  name: 'formEnding',
  initialState: {
    policyNumber: '',
    urls: {
      policy: '',
      rcusa: '',
      receipt: '',
      endoso: '',
      bienvenida: '',
    },
  },
  reducers: {
    setUrls(state, { payload }) {
      state.urls.policy = payload.policy;
      state.urls.rcusa = payload.rcusa;
      state.urls.receipt = payload.receipt;
      state.urls.endoso = payload.endoso;
      state.urls.bienvenida = payload.bienvenida;
    },
  },
});

export const formEndingActions = formEndingSlice.actions;
export default formEndingSlice;
/* eslint-enable no-param-reassign */
